<template>
  <v-dialog
      v-model="isLoading"
      width="auto"
      persistent
      class="rounded-0"
  >
    <v-card class="pa-5 pt-10" tile>
      <v-card-text>
        <div>
          <v-row v-if="!customText">
            Идет сохранение...
          </v-row>

          <v-row v-else>
            {{customText}}
          </v-row>

          <v-row class="justify-center mt-5">
          <v-progress-circular
              indeterminate
              color="primary"
              size="50"
              width="1"
          ></v-progress-circular>
          </v-row>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "LoadingModal",

  props: {
    isLoading: {
      required: true,
      type: Boolean,
    },
    customText: {
      required: false,
      type: String
    }
  }
}
</script>

<style scoped>

</style>